import awards from "../../shared/de.awards";
import branded_quotes from "../../shared/de.branded-quotes";
import verticals from "./de-enterprise.verticals";
const pageFooter = ({ strings }) => {
    return {
        awards: {
            visible: true,
            title: {
                content: strings.awards_header_label,
                align: "center",
                type: "section-title"
            },
            panels: awards({ strings })
        },
        branded_quotes: {
            visible: true,
            title: {
                content: strings.branded_quotes_header_label,
                align: "center",
                type: "section-title"
            },
            panels: branded_quotes({ strings })
        },
        verticals: {
            visible: true,
            title: {
                content: strings.verticals_label,
                align: "center",
                type: "section-title"
            },
            panels: verticals({ strings })
        }
    };
};

export default ({ page, strings }) => {
    switch (page) {
        case "de-enterprise-kontakt":
            return {
                page,
                helmet: {
                    meta_title: "Kontakt | Rosetta Stone",
                    meta_description: "",
                    canonical_url: "https://www.rosettastone.de/unternehmen/kontakt/",
                    lang: "de"
                }
            };
        case "de-enterprise-home":
            return {
                page,
                helmet: {
                    meta_title: "Geschäftssprachentraining, das funktioniert | Rosetta Stone",
                    meta_description:
                        "Die Schulungslösungen von Rosetta Stone helfen den Mitarbeitern, Sprachkenntnisse in Englisch für Unternehmen und viele gefragte Geschäftssprachen zu entwickeln. Preis anfragen",
                    canonical_url: "https://www.rosettastone.de/unternehmen/",
                    lang: "de"
                },
                ...pageFooter({ strings })
            };
        case "de-enterprise-loesungen":
            return {
                page,
                helmet: {
                    meta_title: "Globales Geschäftssprachentraining  | Rosetta Stone Catalyst",
                    meta_description:
                        "Das weltweite Geschäftssprachentraining mit Rosetta Stone Catalyst bietet die Top-Geschäftssprachen, die Mitarbeiter von überall aus lernen können. Firmenpreis anfordern",
                    canonical_url: "https://www.rosettastone.de/unternehmen/losungen/",
                    lang: "de"
                },
                ...pageFooter({ strings })
            };
        case "de-enterprise-dynamic-resources":
            return {
                page,
                helmet: {
                    meta_title: "",
                    meta_description: "",
                    canonical_url: "",
                    lang: "de"
                },
                ...pageFooter({ strings })
            };
        case "de-enterprise-dynamic-content":
            return {
                page,
                helmet: {
                    meta_title: "",
                    meta_description: "",
                    canonical_url: "",
                    lang: "de"
                },
                ...pageFooter({ strings })
            };
        case "de-enterprise-404":
            return {
                page,
                helmet: {
                    meta_title: "Site Nicht Gefunden | Rosetta Stone",
                    meta_description: "",
                    canonical_url: "https://www.rosettastone.de/unternehmen/404",
                    lang: "de"
                },
                ...pageFooter({ strings })
            };
        default:
            return null;
    }
};
